var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPincampradark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_10)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 17.25,
    width: 24.75,
    height: 16.5,
    fill: "url(#pattern0_1_10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.465 28.5525C18.5119 28.5525 21.7925 27.0448 21.7925 25.185C21.7925 23.3252 18.5119 21.8175 14.465 21.8175C10.4181 21.8175 7.1375 23.3252 7.1375 25.185C7.1375 27.0448 10.4181 28.5525 14.465 28.5525Z",
    fill: "#020202"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 9.5C22.75 11.687 21.5082 14.6165 19.8544 17.4306C18.2072 20.2337 16.1802 22.8743 14.6657 24.4712C14.5743 24.5676 14.4257 24.5676 14.3343 24.4712C12.8199 22.8743 10.7928 20.2337 9.14558 17.4306C7.49178 14.6165 6.25 11.687 6.25 9.5C6.25 4.94365 9.94365 1.25 14.5 1.25C19.0563 1.25 22.75 4.94365 22.75 9.5Z",
    fill: "#00581C",
    stroke: "#D7D7D7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8749 6.51724C13.3154 6.51724 12.01 8.15931 12.01 10.5C12.01 12.8407 13.3154 14.4828 14.8749 14.4828C15.9971 14.4828 17.0594 13.6618 17.5917 12.3009C17.7435 11.9127 18.1698 11.7257 18.5438 11.8833C18.9178 12.0409 19.098 12.4833 18.9461 12.8715C18.2483 14.6558 16.7331 16 14.8749 16C12.2607 16 10 13.3965 10 10.5C10 7.60351 12.2607 5 14.8749 5C16.7331 5 18.2483 6.34415 18.9461 8.12845C19.098 8.51666 18.9178 8.95912 18.5438 9.11671C18.1698 9.27429 17.7435 9.08734 17.5917 8.69913C17.0594 7.33822 15.9971 6.51724 14.8749 6.51724Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1_10",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_10",
    transform: "scale(0.030303 0.0454545)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_10",
    width: 33,
    height: 22,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAWCAYAAABOm/V6AAAACXBIWXMAAAsSAAALEgHS3X78AAACvElEQVRIS53WT0gUYRjH8dcxdVdTMWlTtA6SYoF6qGDLDiJ2kS4hdihJCqRAvXQLUsGbQUGQdlDoGHnypChESHgrKBBUgtAuRoGyVlon+77Mb2waZndnDT6Mve/zPs8z7/xbs7+/b6LgX16usuU8yB2xsIN8ORKBF+tEaShbca9oIWIoRgmOZlCiuJjWeU2lbSZdA44Wx5S4AsdRhRrU4mSIWs1XKb5C62PK54Q1EtaA7dqegT2jY0p6Gk04jyQuoRWXfVo1nlRck9bVKE+J8uYHG0nXQClOoF4JO3ANPbiDPtyVe76/+zTfo/gOra9XvtKwRoKXoMC421eNs2jDdQxgCGN4inE8DzGu+THFD2h9m/JVK3+B8V0afxP2msWNey0b0Y5ePMQEXmEWr7GItyEWNT+r+Amt71W+RuWPq95/TXi7UIZTxr2uNzCMF1jAO6zgM9bxJcS65lcUv6D1w8qXVP4y1XOCTRQZ925uwBX04xnm8AEb+IZtpLCDHz47Gt9W3IbWzSlPv/I2qE7RQRPm3/1gBytxBp24jym8wSq+qsgv7OFPiD3NpxS/qvVTytep/JWq577MIu7ER+Oe2XcV+Ild/PbZ1XhKcRtal30ncrgn3mPNuNd+U4W2jLv9W/r/pubXFJ/TPZHp6bCPmr3LpzGPJRVYVrFPOi5rfElx01o3ZCI+HdneE4MYwRNM4iVmjLvV8zrOaHxScSNaF+09EeGNaa9lF24r8QOM4hEe6ziq8UHFdWldtDdmhG+HTdKCi8bd1qvoxk3c0rFb4+2Ka9G66N+OQCN2q4Jf0YRxv5J1xn3MmnEOF3Rs1nid4hLmMF/RQCP+3xP2cYorYblxz8wWsZ/sah0TGi9XXFzrcv89kaYZx9dQoa+pYh+vqP+HjJOpeKQmMjTkNRXkzWUtfKgmMjSVl2vRoL/dHZt1qm8S0wAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPincampradark);
export default __webpack_public_path__ + "static/media/pincampradark.d3475742b29faa68d51f65fe8214ed23.svg";
export { ForwardRef as ReactComponent };